export const BOT_NAME = 'Flow';
export const MESSAGE_ID_PREFIX = 'message-';

export enum AuthorRoles {
  USER = 'user',
  AGENT = 'agent',
  CONTACT = 'contact',
  BOT = 'bot',
}
